import React from 'react';
import { Link } from 'react-router-dom';
import { BsTelephoneFill, BsGeoAltFill } from 'react-icons/bs';
import logoImage from '../assets/images/logo_top_conduite-removebg.png';
import instagramIcon from '../assets/images/instagram-96.png';
import snapchatIcon from '../assets/images/snapchat-96.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <Link to="/" className="footer-logo">
            <img src={logoImage} alt="Top Conduite" className="logo-image" />
            <span>Top Conduite</span>
          </Link>
        </div>

        <div className="footer-section">
          <a href="https://maps.google.com/?q=19+Av.+Franklin+Roosevelt,+77290+Mitry-Mory" target="_blank" rel="noopener noreferrer" className="footer-address">
            <BsGeoAltFill style={{ marginRight: '8px', verticalAlign: 'middle' }} />
            19 Av. Franklin Roosevelt, 77290 Mitry-Mory
          </a>
          <a href="tel:0952655019" className="footer-phone">
            <BsTelephoneFill style={{ marginRight: '8px', verticalAlign: 'middle' }} />
            09 52 65 50 19
          </a>
        </div>

        <div className="footer-section">
          <nav className="footer-nav">
            <Link to="/">Accueil</Link>
            <Link to="/formations">Formations</Link>
            <Link to="/avis">Avis</Link>
            <Link to="/contact">Contact</Link>
          </nav>
          <div className="social-icons">
            <a href="https://www.instagram.com/ae.topconduite/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon">
              <img src={instagramIcon} alt="Instagram" />
            </a>
            <a href="https://www.snapchat.com/add/aetopconduite" target="_blank" rel="noopener noreferrer" aria-label="Snapchat" className="social-icon">
              <img src={snapchatIcon} alt="Snapchat" />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-credit">
        Made by Mele Elyes
      </div>
    </footer>
  );
};

export default Footer;
